<script>
	import { onMount } from 'svelte';
	import ComponentPageHead from '$lib/components/ComponentPageHead.svelte';
	export let data;
	const { page } = data;

	/**
	 * @type {typeof import('svelte').SvelteComponent}
	 */
	let Component; //TODO: NEED TO THINK ABOUT BEST APPROACH FOR THIS FOR SSR

	onMount(async () => {
		Component = await page.init();
	});
</script>

{#if data.metadata}
	<ComponentPageHead content={data.metadata} />
{/if}

{#if Component}
	<!-- Fallback Component is handled in the resolveCondition method -->
	<svelte:component this={Component} />
{/if}
